import React from "react";
import { IoClose } from "react-icons/io5";
import { MdLocalShipping } from "react-icons/md";

/**
 * The toolbar's Self delivery switch: on, the list shows only self-delivery
 * orders and the routes bar opens; clicking it again goes back to all orders.
 * `on` follows the Type filter, so picking Self Delivery in the Order heading
 * turns it on too.
 */
const SelfDeliveryToggle = ({ on, onChange }) => (
  <button
    type="button"
    aria-pressed={on}
    onClick={() => onChange(!on)}
    title={
      on ? "Back to all orders" : "Show self-delivery orders and their routes"
    }
    className={`flex items-center gap-[5px] whitespace-nowrap rounded-md border px-[13px] py-[5px] text-xs font-semibold transition-colors ${
      on
        ? "border-brand bg-brand-light text-brand"
        : "border-ui-border bg-ui-surface text-ui-text-muted hover:border-brand hover:bg-brand-light hover:text-brand"
    }`}
  >
    <MdLocalShipping className="h-3 w-3 shrink-0" />
    Self delivery
    {on && (
      <IoClose aria-hidden="true" className="-mr-[3px] h-3 w-3 shrink-0" />
    )}
  </button>
);

export default SelfDeliveryToggle;
